<template>
    <div class="sports-admin-view">
        <AdminTable @edit:item="onEditItem($event)"
                    class="ma-4"
                    :items="items"
                    :get-new-item="getNewItem"
                    :get-headers="getHeaders"
                    create-button-text="Создать спорт" />

        <HobbyDialog v-if="showEditDialog"
                     @hide="hideEditDialog"
                     :item="editedItem"
                     :items="items"
                     :edit="editItem"
                     edit-title="Редактирование спорта"
                     create-title="Создание спорта"
                     name-label="Название спорта"
                     @update:item="upsertServerItem($event)" />
    </div>
</template>

<script>
    import AdminTable from "@/components/admin/AdminTable.vue";
    import HobbyDialog from "@/components/admin/HobbyDialog.vue";

    export default {
        components: {
            AdminTable,
            HobbyDialog
        },

        data() {
            return {
                showEditDialog: false,
                editItem: false,
                editedItem: null
            };
        },

        created() {
            this.$store.dispatch("admin/loadSports");
        },

        computed: {
            items() {
                return this.$store.state.admin.sports
                    .map(e => ({
                        id: e.id,
                        name: e.name,
                        availableOutside: this.getBoolString(e.availableOutside),
                        availableIndoors: this.getBoolString(e.availableIndoors),
                        isGreyRow: false,
                        rawItem: e
                    }));
            }
        },

        watch: {

        },

        methods: {
            getNewItem() {
                return {
                    id: 0,
                    name: "",
                    availableOutside: true,
                    availableIndoors: true
                };
            },

            onEditItem(data) {
                this.showEditDialog = true;
                this.editItem = data.editItem;
                this.editedItem = data.item;
            },

            hideEditDialog() {
                this.showEditDialog = false;
                this.editItem = false;
                this.editedItem = null;
            },

            upsertServerItem(sport) {
                this.$store.dispatch("admin/upsertSport", sport)
                    .then(() => {
                        this.$store.dispatch("admin/loadSports");
                    });
            },

            getBoolString(bool) {
                return bool === true
                    ? "Да"
                    : "Нет";
            },

            getHeaders() {
                return [
                    {
                        title: "Id",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "id"
                    },
                    {
                        title: "Название",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "name"
                    },
                    {
                        title: "На улице",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "availableOutside"
                    },
                    {
                        title: "В помещении",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "availableIndoors"
                    },
                    {
                        title: "",
                        align: "end",
                        sortable: false,
                        removable: true,
                        key: "buttons"
                    }
                ];
            }
        }
    };
</script>

<style lang="scss">
    .sports-admin-view {
    }
</style>